import { SortDirection } from '@angular/material/sort';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PAGE_SIZE_DEFAULT } from '../../_common/constants';
import { NonFiscalsListResponse } from './non-fiscals.model';

@Injectable({
  providedIn: 'root'
})

export class NonFiscalsService {
  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
  ) { }

  getNonFiscalsDocuments(pageIndex: number = 0, pageSize: number = PAGE_SIZE_DEFAULT, sortBy: string, sortDir: SortDirection, filter: any): Observable<NonFiscalsListResponse> {
    return this.http
      .post<NonFiscalsListResponse>(
        this.apiUrl + 'nonFiscal/non-fiscal',
        {
          pageNumber: pageIndex,
          pageSize,
          sortBy,
          sortDir,
          filter: JSON.stringify(filter)
        }
      );
  }
}
